import { render, staticRenderFns } from "./HolderUpsert.vue?vue&type=template&id=fbf10d7c&scoped=true"
import script from "./HolderUpsert.vue?vue&type=script&lang=js"
export * from "./HolderUpsert.vue?vue&type=script&lang=js"
import style0 from "./HolderUpsert.vue?vue&type=style&index=0&id=fbf10d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf10d7c",
  null
  
)

export default component.exports